import React from 'react'
import { ActivityIndicator } from 'react-native'
import { atlTheme } from '../../atlTheme'

export const Loading: React.FC<{ color?: string; size?: 'small' | 'large' }> = ({ color, size }) => {
  return <ActivityIndicator color={color ? color : atlTheme.ColorBrand1Default} size={size ? size : 'large'} />
}
